module.exports = __webpack_public_path__ + "img/vest-patches.a994d425.svg";